<script setup lang="ts" generic="T = string | number">
import { VBtnToggle, VBtn } from 'vuetify/components';

type ToggleOption<T> = {
    value: T;
    label: string;
    icon?: string;
    disabled?: boolean;
};

type PropsType = {
    modelValue?: T;
    options: ToggleOption<T>[];
    variant?: VBtnToggle['$props']['variant'];
    mandatory?: boolean;
    multiple?: boolean;
    color?: string;
    baseColor?: string;
    density?: VBtnToggle['$props']['density'];
    rounded?: boolean | string;
    divided?: boolean;
    borderless?: boolean;
    elevation?: number;
    disabled?: boolean;
    selectedClass?: string;
    size?: VBtn['$props']['size'];
    showIcons?: boolean;
    iconPosition?: 'start' | 'end';
};

const props = withDefaults(defineProps<PropsType>(), {
    mandatory: true,
    multiple: false,
    color: 'primary',
    density: 'default',
    size: 'default',
    showIcons: true,
    iconPosition: 'start',
    divided: false,
});

defineEmits<{
    'update:modelValue': [value: T];
}>();

defineOptions({ inheritAttrs: false });
</script>

<template>
    <VBtnToggle
        :model-value="props.modelValue"
        :mandatory="props.mandatory"
        :multiple="props.multiple"
        :color="props.color"
        :base-color="props.baseColor"
        :density="props.density"
        :rounded="props.rounded"
        :divided="props.divided"
        :borderless="props.borderless"
        :elevation="props.elevation"
        :disabled="props.disabled"
        :selected-class="props.selectedClass"
        :variant="props.variant"
        v-bind="$attrs"
        @update:model-value="$emit('update:modelValue', $event)"
    >
        <VBtn
            v-for="option in props.options"
            :key="String(option.value)"
            :value="option.value"
            :disabled="option.disabled"
            :size="props.size"
            :prepend-icon="props.showIcons && props.iconPosition === 'start' ? option.icon : undefined"
            :append-icon="props.showIcons && props.iconPosition === 'end' ? option.icon : undefined"
        >
            {{ option.label }}
        </VBtn>
    </VBtnToggle>
</template>
